var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAttendance = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8345",
    "data-name": "Path 8345",
    d: "M8.373,2a6.373,6.373,0,1,0,6.373,6.373A6.376,6.376,0,0,0,8.373,2ZM7.1,11.56,3.912,8.373l.9-.9L7.1,9.757l4.837-4.837.9.905Z",
    transform: "translate(0 0)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttendance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attendance.752db1e4.svg";
export { ForwardRef as ReactComponent };